core-button {
  display: flex;
}

.core-button {
  --border-width: 1px;
  --outline-width: 2px;
  --outline-offset: 2px;
  display: flex;
  align-items: center;
  gap: var(--number-spacing-4xsmall);
  border-style: none;
  border: 3px solid red;
  cursor: pointer;
  transition: background-color var(--motion-duration-fast) var(--motion-easing-move),
  color var(--motion-duration-fast) var(--motion-easing-move),
  border var(--motion-duration-fast) var(--motion-easing-move);
}

.core-button core-icon {
  display: flex;
}

.core-button:disabled {
  cursor: not-allowed;
}

/* variant classes */
/* Disabled button should not have borders */
.core-button--primary:not(:disabled) {
  border: var(--border-width) solid var(--color-action-primary-border-default);
  background-color: var(--color-action-primary-background-default);
  color: var(--color-action-primary-content-default);
}

.core-button--primary:not(:disabled):hover {
  border: var(--border-width) solid var(--color-action-primary-border-interacting);
  background-color: var(--color-action-primary-background-interacting);
  color: var(--color-action-primary-content-interacting);
}

.core-button--primary:not(:disabled):focus-visible {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
  border: var(--border-width) solid var(--color-action-primary-border-interacting);
  background-color: var(--color-action-primary-background-interacting);
  color: var(--color-action-primary-content-interacting);
}

.core-button--secondary:not(:disabled) {
  border: var(--border-width) solid var(--color-action-secondary-border-default);
  background-color: var(--color-action-secondary-background-default);
  color: var(--color-action-secondary-content-default);
}

.core-button--secondary:not(:disabled):hover {
  border: var(--border-width) solid var(--color-action-secondary-border-interacting);
  background-color: var(--color-action-secondary-background-interacting);
  color: var(--color-action-secondary-content-interacting);
}

.core-button--secondary:not(:disabled):focus-visible {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
  border: var(--border-width) solid var(--color-action-secondary-border-interacting);
  background-color: var(--color-action-secondary-background-interacting);
  color: var(--color-action-secondary-content-interacting);
}

.core-button--tertiary:not(:disabled) {
  border: var(--border-width) solid var(--color-action-tertiary-border-default);
  background-color: var(--color-action-tertiary-background-default);
  color: var(--color-action-tertiary-content-default);
}

.core-button--tertiary:not(:disabled):hover {
  border: var(--border-width) solid var(--color-action-tertiary-border-interacting);
  background-color: var(--color-action-tertiary-background-interacting);
  color: var(--color-action-tertiary-content-interacting);
}

.core-button--tertiary:not(:disabled):focus-visible {
  outline: var(--outline-width) solid var(--color-global-border-focus);
  outline-offset: var(--outline-offset);
  border: var(--border-width) solid var(--color-action-tertiary-border-interacting);
  background-color: var(--color-action-tertiary-background-interacting);
  color: var(--color-action-tertiary-content-interacting);
}

/* size classes */
/* As the height should not be fixed the use of box-sizing property is not possible */
/* Instead the border size is removed from the padding */
.core-button--small:not(:disabled) {
  border-radius: var(--number-radius-medium);
  padding: calc(var(--number-spacing-2xsmall) - var(--border-width)) calc(var(--number-spacing-xsmall) - var(--border-width));
}

.core-button--medium:not(:disabled) {
  border-radius: var(--number-radius-medium);
  padding: calc(var(--number-spacing-small) - var(--border-width)) calc(var(--number-spacing-medium) - var(--border-width));
}

.core-button--large:not(:disabled) {
  border-radius: var(--number-radius-large);
  padding: calc(var(--number-spacing-small) - var(--border-width)) calc(var(--number-spacing-large) - var(--border-width));
}

.core-button--primary:disabled, .core-button--secondary:disabled {
  background-color: var(--color-global-all-disabled-soft);
  color: var(--color-global-all-disabled-strong);
}

.core-button--primary:disabled, .core-button--secondary:disabled, .core-button--tertiary:disabled {
  border: 0;
}

.core-button--tertiary:disabled {
  background-color: transparent;
  color: var(--color-global-all-disabled-strong);
}

.core-button--small.core-button--primary:disabled, .core-button--small.core-button--secondary:disabled, .core-button--small.core-button--tertiary:disabled {
  border-radius: var(--number-radius-small);
  padding: var(--number-spacing-2xsmall) var(--number-spacing-xsmall);
}

.core-button--medium.core-button--primary:disabled, .core-button--medium.core-button--secondary:disabled, .core-button--medium.core-button--tertiary:disabled  {
  border-radius: var(--number-radius-medium);
  padding: var(--number-spacing-small) var(--number-spacing-medium);
}

.core-button--large.core-button--primary:disabled, .core-button--large.core-button--secondary:disabled, .core-button--large.core-button--tertiary:disabled {
  border-radius: var(--number-radius-large);
  padding: var(--number-spacing-small) var(--number-spacing-large);
}

/* icon position classes */
/* icon small */
.core-button--small.icon-position--left:not(:disabled) {
  padding-left: calc(var(--number-spacing-2xsmall) - var(--border-width));
}
.core-button--small.icon-position--left:disabled {
  padding-left: var(--number-spacing-2xsmall);
}
.core-button--small.icon-position--right:not(:disabled) {
  padding-right: calc(var(--number-spacing-2xsmall) - var(--border-width));
}
.core-button--small.icon-position--right:disabled {
  padding-right: var(--number-spacing-2xsmall);
}

/* icon medium */
.core-button--medium.icon-position--left:not(:disabled) {
  padding-left: calc(var(--number-spacing-small) - var(--border-width));
}
.core-button--medium.icon-position--left:disabled {
  padding-left: var(--number-spacing-small);
}
.core-button--medium.icon-position--right:not(:disabled) {
  padding-right: calc(var(--number-spacing-small) - var(--border-width));
}
.core-button--medium.icon-position--right:disabled {
  padding-right: var(--number-spacing-small);
}

/* icon large */
.core-button--large.icon-position--left:not(:disabled) {
  padding-left: calc(var(--number-spacing-medium) - var(--border-width));
}
.core-button--large.icon-position--left:disabled {
  padding-left: var(--number-spacing-medium);
}
.core-button--large.icon-position--right:not(:disabled) {
  padding-right: calc(var(--number-spacing-medium) - var(--border-width));
}
.core-button--large.icon-position--right:disabled {
  padding-right: var(--number-spacing-medium);
}
